var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-draggable-resize-combo",
    {
      staticClass: "container",
      attrs: {
        x: _vm.image.X,
        y: _vm.image.Y,
        width: _vm.image.Width,
        height: _vm.image.Height,
        "min-width": 5,
        "min-height": 5,
      },
      on: {
        "update:x": function ($event) {
          return _vm.$set(_vm.image, "X", $event)
        },
        "update:y": function ($event) {
          return _vm.$set(_vm.image, "Y", $event)
        },
        "update:width": function ($event) {
          return _vm.$set(_vm.image, "Width", $event)
        },
        "update:height": function ($event) {
          return _vm.$set(_vm.image, "Height", $event)
        },
      },
    },
    [
      _c("img", {
        staticClass: "image",
        attrs: { src: _vm.image.getEditorImageUrl(), alt: "Image" },
        on: {
          mousedown: function ($event) {
            $event.preventDefault()
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }